module.exports = __webpack_public_path__ + "static/media/CheckMarkOrange.173ff8ee.png";